// Externe Bibliotheken
import React, { Component } from 'react';
import axios from 'axios';
import FileSaver from 'file-saver';

// Interne Module
import * as storage from '@/_helper/storage';

// Styles
import './documents.scss';

class Index extends Component {
    state = {
        isLoading: false,
        error: false,
        link: this.props.link !== undefined,
    };

    renderType = {
        railAndFly: '',
        transfer: 'transferOnly',
        excursion: 'excursion',
        seatReservation: 'seatReservation',
    };

    documentList = {
        traveldocument: 'traveldocuments',
        terms: 'terms',
        invoicedocument: 'invoiceDocument',
        chattelpaper: 'bookingConfirmation',
        privacy: 'terms',
        travelGuide: 'travelGuide',
    };

    loadFile() {
        this.setState({
            isLoading: true,
        });

        const bookingNumber = storage.get('bookingNumber');

        if (bookingNumber && this.documentList[this.props.name] !== undefined) {
            let renderType = '';
            if (this.props.renderType) {
                renderType =
                    this.renderType[this.props.renderType] !== undefined ? this.renderType[this.props.renderType] : '';
            }

            axios({
                url:
                    window.$serviceUrl +
                    '/documentservice?bookingId=' +
                    bookingNumber +
                    '&service=' +
                    this.documentList[this.props.name] +
                    '&rendertype=' +
                    renderType +
                    '&requestType=documentservice&clientId=customerarea&token=' +
                    window.$token,
                method: 'GET',
            })
                .then((response) => response)
                .then((data) => {
                    let fileService, fileName;
                    let error = false;

                    if (
                        data?.data?.data?.documents !== undefined &&
                        Object.keys(data?.data?.data?.documents).length > 0
                    ) {
                        data.data.data.documents.forEach((item) => {
                            if (fileName === undefined && item.documentType === this.props.name) {
                                fileService = item.content;
                                fileName = item.name;
                            }
                        });

                        const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
                            const byteCharacters = atob(b64Data);
                            const byteArrays = [];

                            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                                const slice = byteCharacters.slice(offset, offset + sliceSize);

                                const byteNumbers = new Array(slice.length);
                                for (let i = 0; i < slice.length; i++) {
                                    byteNumbers[i] = slice.charCodeAt(i);
                                }

                                const byteArray = new Uint8Array(byteNumbers);
                                byteArrays.push(byteArray);
                            }

                            const blob = new Blob(byteArrays, { type: contentType });
                            return blob;
                        };

                        const blob = b64toBlob(fileService, 'application/octet-stream', 1024);
                        FileSaver.saveAs(blob, fileName);
                    } else {
                        error = true;
                        if (this.props.errorHandling) {
                            this.props.errorHandling(true);
                        }
                    }

                    this.setState({
                        isLoading: false,
                        error: error,
                    });
                })
                .catch(() => {
                    if (this.props.errorHandling) {
                        this.props.errorHandling(true);
                    }
                    this.setState({
                        isLoading: false,
                        error: true,
                    });
                });
        } else {
            if (this.props.errorHandling) {
                this.props.errorHandling(true);
            }
            this.setState({
                isLoading: false,
                error: true,
            });
        }
    }

    getIcon() {
        if (!this.state.isLoading && !this.state.error) {
            return <i className="icon-arrow material-symbols-outlined">arrow_forward_ios</i>;
        } else if (this.state.isLoading) {
            return <span className="loader petrol"></span>;
        } else if (this.state.error) {
            return <i className="icon-error material-symbols-outlined">report</i>;
        }
    }

    render() {
        return (
            <>
                {this.state.link ? (
                    <>
                        <div
                            className={
                                'button-element button-ghost document-container-link ' +
                                (this.state.isLoading ? 'loading ' : '') +
                                (this.state.error ? 'error' : '')
                            }
                            onClick={() => {
                                this.loadFile();
                            }}>
                            <span className="document-title">
                                {this.state.isLoading
                                    ? this.props.label_loading !== undefined
                                        ? this.props.label_loading
                                        : this.props.label
                                    : this.props.label}
                            </span>
                            {this.state.isLoading && <span className="loader petrol"></span>}
                        </div>
                    </>
                ) : (
                    <div className="document-container">
                        <div
                            className={
                                'document ' +
                                (this.state.isLoading ? 'loading ' : '') +
                                (this.state.error ? 'error' : '')
                            }
                            onClick={() => {
                                this.loadFile();
                            }}>
                            <i className="icon-pdf material-symbols-outlined">picture_as_pdf</i>
                            <span className="document-title">{this.props.label}</span>
                            {this.getIcon()}
                        </div>
                        {this.state.error && (
                            <p className="error-text">
                                Hier ist wohl etwas schiefgelaufen! Bitte versuchen Sie es erneut oder wenden Sie sich
                                an unser Serviceteam.
                            </p>
                        )}
                    </div>
                )}
                {this.props.errorHandling === undefined && this.state.link && this.state.error && (
                    <p className="error-text">
                        Hier ist wohl etwas schiefgelaufen! Bitte versuchen Sie es erneut oder wenden Sie sich an unser
                        Serviceteam.
                    </p>
                )}
            </>
        );
    }
}

export default Index;
